import { Mapper } from "../../../../base/utils/mapper";
import { TypeRetinoscopyModel } from "../../../../domain/models/consult/type-retinoscopy.model";
import { TypeRetinoscopyEntity } from "../entities/type-retinoscopy.entity";


export class TypeRetinoscopyImplementationRepositoryMapper extends Mapper<TypeRetinoscopyEntity, TypeRetinoscopyModel> {
    mapFrom(param: TypeRetinoscopyEntity): TypeRetinoscopyModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeRetinoscopyModel): TypeRetinoscopyEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}